import { formatCpf, formatPhone } from "../utils/validation.js";

function toChoice(value) {
  if (typeof value === "boolean") return value ? "sim" : "nao";

  const normalized = String(value ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase();

  if (["sim", "true", "1", "on"].includes(normalized)) return "sim";
  if (["nao", "false", "0", "off"].includes(normalized)) return "nao";
  return "";
}

function toBoolean(value) {
  return toChoice(value) === "sim";
}

function toFormDate(value) {
  const date = String(value ?? "").trim();
  const brazilianDate = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(date);
  return brazilianDate ? `${brazilianDate[3]}-${brazilianDate[2]}-${brazilianDate[1]}` : date;
}

function toBedPreference(value) {
  const normalized = String(value ?? "").trim().toLowerCase();
  if (normalized.includes("casal")) return "casal";
  if (normalized.includes("duas") || normalized.includes("2 cama")) return "duas";
  return "";
}

function toAccessibilityDetails(value) {
  const options = Array.isArray(value) ? value : value ? [value] : [];
  return options
    .map((option) => String(option).trim())
    .filter(Boolean)
    .join(", ");
}

export function mapRegistrationToForm(data = {}) {
  const hasSpecialNeeds = toChoice(data.necessidades ?? data.hasSpecialNeeds);
  const hasHealthPlan = toChoice(data.planosaude ?? data.hasHealthPlan);
  const companion = toChoice(data.acompanhante ?? data.companion);
  const dietaryRestrictions = toChoice(data.alimentos ?? data.dietaryRestrictions);
  const accessibilityDetails = toAccessibilityDetails(data.especiais ?? data.accessibilityDetails ?? data.accessibility);

  return {
    name: data.name ?? "",
    surname: data.sobrenome ?? data.surname ?? "",
    ibm: String(data.ibmposto ?? data.ibm ?? ""),
    cpf: formatCpf(data.numerocpf ?? data.cpf ?? ""),
    birthDate: toFormDate(data.nascimento ?? data.birthDate),
    email: data.email ?? "",
    phone: formatPhone(data.celular ?? data.phone ?? ""),
    hasSpecialNeeds,
    specialNeedsDetails: hasSpecialNeeds === "sim" ? (data.qualnecessidade ?? data.specialNeedsDetails ?? "") : "",
    hasHealthPlan,
    healthPlanName: hasHealthPlan === "sim" ? (data.qualplano ?? data.healthPlanName ?? "") : "",
    companion,
    companionName: companion === "sim" ? (data.nomeacompanhante ?? data.companionName ?? "") : "",
    companionSurname: companion === "sim" ? (data.sobrenomeacompanhante ?? data.companionSurname ?? "") : "",
    companionBirthDate: companion === "sim" ? toFormDate(data.nascimentoacompanhante ?? data.companionBirthDate) : "",
    companionCpf: companion === "sim" ? formatCpf(data.cpfacompanhante ?? data.companionCpf ?? "") : "",
    originCity: data.cidadeorigem ?? data.originCity ?? "",
    arrivalTime: data.horarioprevisto ?? data.arrivalTime ?? "",
    bedPreference: toBedPreference(data.camas ?? data.bedPreference),
    dietaryRestrictions,
    dietaryDetails: dietaryRestrictions === "sim" ? (data.qualalimento ?? data.dietaryDetails ?? "") : "",
    hasAccessibilityNeeds: accessibilityDetails ? "sim" : "nao",
    accessibilityDetails,
    acceptPrivacy: toBoolean(data.declaro ?? data.acceptPrivacy),
  };
}
